import React, {useContext} from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { LabelText } from '../../components/Language';
import {CalendarIntakeBookContext} from '../contexts/CalendarIntakeBookProvider';
import HeaderTitle from '../../hoc/HeaderTitle';
import './index.css';

function MonthlyIntakeBookHeader(props) {

  const { setShowInstructions } = useContext(CalendarIntakeBookContext);


  const helpTooltip = (
    <Tooltip id="helpButton">
      <LabelText tid="help" />
    </Tooltip>
  )
  
  const showInstructions = () => {
    setShowInstructions(true)
  }

  return (
    <>     
      <HeaderTitle className = "monthly-intakebook-header-code-col col">
        <span className="monthly-intakebook-header-title-align">
          <LabelText tid="monthly_intakebook" />
        </span>
        <span className="monthly-intakebook-header-code-align">
          {props.BusinessPartnerCode}
        </span>
      </HeaderTitle>

      <HeaderTitle className = "monthly-intakebook-header-instructions-col col">
        <div role="button" title="Help button" onClick={showInstructions} tabIndex="0"
        onKeyDown={(e) => { if (e.key === "Enter") showInstructions()}}  >
          <OverlayTrigger placement="bottom" overlay={helpTooltip}>
            <FontAwesomeIcon className="fa-help-icon" icon= {faInfoCircle} /> 
          </OverlayTrigger>
        </div>
      </HeaderTitle>
    </>
  );
}

export default MonthlyIntakeBookHeader;


